let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l92K1")).then(() => parcelRequire('AFwEY'));